import { Routes } from '@angular/router';
import { MainLayoutComponent } from './layout/layout.component';
import { AuthGuard } from './guards/auth.guard';
import { TransactionGuard } from './guards/transaction.guard';

export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'about',
        loadComponent: () => import('./pages/about/about.component')
          .then(m => m.AboutComponent),
        title: 'Sobre NÃ³s - Hiquotroca'
      },
      {
        path: 'lotteries/mine',
        loadComponent: () => import('./pages/lotteries/my-lotteries/my-lotteries.component')
          .then(m => m.MyLotteriesComponent),
        canActivate: [AuthGuard],
        title: 'Meus Sorteios - Hiquotroca'
      },
      {
        path: 'lotteries/:id/numbers',
        loadComponent: () => import('./pages/lotteries/lottery-numbers/lottery-numbers.component')
          .then(m => m.LotteryNumbersComponent),
        canActivate: [AuthGuard],
        title: 'Escolhe os teus nÃºmeros - Hiquotroca'
      },
      {
        path: 'lotteries/:id/summary',
        loadComponent: () => import('./pages/lotteries/lottery-summary/lottery-summary.component')
          .then(m => m.LotterySummaryComponent),
        canActivate: [AuthGuard],
        title: 'Resumo do sorteio - Hiquotroca'
      },
      {
        path: 'lotteries/:id',
        loadComponent: () => import('./pages/lotteries/lottery-detail/lottery-detail.component')
          .then(m => m.LotteryDetailComponent),
        canActivate: [AuthGuard],
        title: 'Lotaria - Hiquotroca'
      },
      {
        path: 'lotteries',
        loadComponent: () => import('./pages/lotteries/lotteries.component')
          .then(m => m.LotteriesComponent),
        title: 'Sorteios em vigor - Hiquotroca'
      },
      {
        path: '',
        loadComponent: () => import('./pages/homepage/homepage.component')
          .then(m => m.HomepageComponent),
        title: 'Hiquotroca'
      },
      {
        path: 'auth',
        loadChildren: () => import('./routes/auth.routes')
          .then(m => m.AUTH_ROUTES)
      },
     /*  {
        path: 'product/:id',
        loadComponent: () => import('./pages/homepage/components/product-detail-dialog/product-detail-dialog.component')
          .then(m => m.ProductDetailComponent),
        canActivate: [AuthGuard],
        resolve: { product: ProductDetailResolver },
        title: 'Detalhes do Produto - Hiquotroca'
      }, */
      {
        path: 'profile',
        loadComponent: () => import('./pages/profile/profile.component')
          .then(m => m.ProfileComponent),
        canActivate: [AuthGuard],
        title: 'Hiquotroca - Perfil'
      },
      {
        path: 'my-products',
        loadComponent: () => import('./pages/user-products/user-products.component')
          .then(m => m.UserProductsComponent),
        canActivate: [AuthGuard],
        title: 'Os Meus Produtos - Hiquotroca'
      },
       {
        path: 'my-favorites',
        loadComponent: () => import('./pages/my-favorites/my-favorites.component')
          .then(m => m.MyFavoritesComponent),
        canActivate: [AuthGuard],
        title: 'Os Meus Favoritos - Hiquotroca'
      },
      {
        path: 'post',
        canActivate: [AuthGuard, TransactionGuard],
        loadChildren: () => import('./routes/post.routes')
          .then(m => m.POST_ROUTES)
      },
      {
        path: 'chat',
        canActivate: [AuthGuard],
        loadChildren: () => import('./routes/chat.routes')
          .then(m => m.CHAT_ROUTES)
      },
      {
        path: 'wallet',
        loadComponent: () => import('./pages/wallet/wallet.component')
          .then(m => m.WalletComponent),
        title: 'Carteira - Hiquotroca'
      },

      // === Legal ===
      {
        path: 'terms',
        loadComponent: () => import('./pages/legal/terms/terms.component').then(m => m.TermsComponent),
        title: 'Termos e CondiÃ§Ãµes - Hiquotroca'
      },
      // === Support ===
      {
        path: 'help',
        loadComponent: () => import('./pages/help/help.component').then(m => m.HelpComponent),
        title: 'Ajuda - Hiquotroca'
      },
      // === Fallback ===
      { path: '**', redirectTo: '' }
    ]
  }
];
